import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import "./rich.css";

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    [{ size: ["small", false, "large", "huge"] }],
    ["bold", "italic", "underline"],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["clean"],
  ],
};

const formats = ["header", "size", "bold", "italic", "underline", "color", "background", "list"];

export function RichTextEditor({ value, onChange, placeholder, testid }) {
  return (
    <div className="rte-wrap" data-testid={testid}>
      <ReactQuill theme="snow" value={value || ""} onChange={onChange} modules={modules} formats={formats} placeholder={placeholder} />
    </div>
  );
}

export function RichContent({ html, className = "" }) {
  if (!html) return null;
  return (
    <div className={`ql-snow rich-display ${className}`}>
      <div className="ql-editor" dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
